import { FC, useEffect } from "react"
import React from "react"

import { DialogContent, DialogTitle, Grid, SxProps, Typography } from "../../../../../ui-component/mui.components"

import { BootstrapDialog } from "./ExistingPatientCheckModal.style"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import PatientInfoHeader from "../PatientInfoHeader"
import { fetchPatientById } from "@/core/app/slices/patients"
import { getCaseByPatient } from "@/core/app/slices/case"
import { UButton } from "@/ui-component"
import RenderByCaseStatus from "../../RenderByCaseStatus"
import { useTranslation } from "react-i18next"

export interface ImodalProps {
  /**
   * boolean value to indicate whether to show the modal
   */
  isOpen: boolean
  patient: {
    firstName:string
    id: number
    lastName: string
    orgId: number
    } | null
  setClose: ()=> void
  sxModalProps?: SxProps
  createNewCase: () => void
}

const ExistingPatientCheckModal: FC<ImodalProps> = ({
  isOpen,
  patient,
  setClose,
  sxModalProps,
  createNewCase
  }) => {
  const { caseList } = useAppSelector((state: RootState) => state.caseService)
  const { patientData } = useAppSelector(
    (state: RootState) => state.patientService,
  )
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()
  useEffect(() => {
    if(patient && isOpen){
      const patientId = patient?.id.toString()
      dispatch(getCaseByPatient({ patientId: patientId, isCaseArchived: true }))
      dispatch(fetchPatientById({ patientId }))
    }
  }, [patient, isOpen])
    
  return (
    <BootstrapDialog open={isOpen} sx={{ ...sxModalProps }}>
      <DialogTitle id="titleCntr">
        <Grid display={"flex"} flexDirection={"column"}>
          <Typography variant="h5">
            {t("existingPatientModal.title")}
          </Typography>
          <Typography variant="body1">
            {t("existingPatientModal.description")}
          </Typography>
        </Grid>
      </DialogTitle>
      <DialogContent id="contentCntr">
        <Grid>
          <PatientInfoHeader
            status={caseList[0]?.case_disposition}
            patientData={patientData}
            caseDetail={!!caseList[0] && caseList[0]}
          />
        </Grid>
        <Grid>
          <RenderByCaseStatus />
        </Grid>
      </DialogContent>
      <Grid
        id="btnListCntr"
        container
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Grid flexDirection={"row"} justifyContent={"flex-start"}>
          <UButton
            variant="outlined"
            btnText={t("button.back")}
            sxProp={{
              minWidth: 58,
              height: 36,
            }}
            onClickHandler={setClose}
          ></UButton>
        </Grid>
        <Grid flexDirection={"row"} justifyContent={"flex-end"}>
          <UButton
            variant="shade"
            btnText={t("existingPatientModal.createNewPatient")}
            sxProp={{
              minWidth: 58,
              height: 36,
              marginRight: 1,
            }}
            onClickHandler={setClose}
          ></UButton>
          <UButton
            variant="contained"
            btnText={t("existingPatientModal.createNewCase")}
            sxProp={{
              minWidth: 54,
              height: 36,
              boxShadow:
                "0px 1px 5px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
            }}
            onClickHandler={createNewCase}
          ></UButton>
        </Grid>
      </Grid>
    </BootstrapDialog>
  )
}

export default ExistingPatientCheckModal
